<template>
    <div v-for="(col, index) in chunk(useMenuStore().footerMain, 5)" class="footer-item mb-4">
        <ul class="list-unstyled mb-0">
            <li
                v-for="(item, index) in col"
                :class="{ 'mb-2': index < col.length - 1 }"
            >
                <template v-if="item.link || item.link === '#'">
                    <NuxtLink
                        :to="item.link"
                        :title="item.title"
                        :class="item.class"
                        :rel="item.nofollow ? 'nofollow' : ''"
                    >
                        {{ item.title }}
                    </NuxtLink>
                </template>
                <template v-else>
                    <span>{{ item.title }}</span>
                </template>
            </li>
        </ul>

        <ul v-if="index === chunk(useMenuStore().footerMain, 5).length-1" class="list-unstyled">
            <li class="mb-2">
                <a class="footer-payment" style="pointer-events: none; cursor: default;" href="" :title="$t('We accept credit cards')">
                    <div class="d-flex flex-row align-content-center pb-1">
                        <img height="40" :src="$cdn(`/img/payment/visa.webp`)" title="Visa" alt="Visa" loading="lazy"/>
                        <img height="40" :src="$cdn(`/img/payment/mastercard.webp`)" title="Mastercard" alt="Mastercard" loading="lazy"/>
                    </div>
                    <img height="15" :src="$cdn(`/img/payment/bank-transfer.webp`)" title="Bank transfer" alt="Bank transfer" loading="lazy"/>
                </a>
            </li>
        </ul>
    </div>
</template>

<script setup>
const { $cdn } = useNuxtApp()

import {useMenuStore} from '~/stores/MenuStore';

import pkg from 'lodash';
const { chunk } = pkg;
</script>
